import { render, staticRenderFns } from "./LawsDetail.vue?vue&type=template&id=165b357e&scoped=true&"
import script from "./LawsDetail.vue?vue&type=script&lang=js&"
export * from "./LawsDetail.vue?vue&type=script&lang=js&"
import style0 from "./LawsDetail.vue?vue&type=style&index=0&id=165b357e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b357e",
  null
  
)

export default component.exports